import http from "../http";
import Service from "../../Service";

/**
 * @type RequestProductService
 */
export default class RequestProductService extends Service {

    products(id, params = {}, config = {}) {

        return http.get(
            `/clients/requests/${id}/products`,
            {
                headers: this.getHeaders(),
                params,
                ...config,
            }
        );
    }

    resupply_products(id, params = {}, config = {}) {

        return http.get(
            `/clients/requests/${id}/products/resupply`,
            {
                headers: this.getHeaders(),
                params,
                ...config,
            }
        );
    }

    update_replenishment_strategy(id, product_id, replenishment_strategy) {
        return http.patch(
            `/clients/requests/${id}/products/${product_id}/replenishment-strategy`,
            { replenishment_strategy },
            { headers: this.getHeaders() }
        );
    }

}
